/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function openShippingProtectionModal() {
    var modal = document.getElementById('shipping-protection-modal');
    if (modal) {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
    }
  }

  function closeShippingProtectionModal() {
    var modal = document.getElementById('shipping-protection-modal');
    if (modal) {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    }
  }

  function wireModalClose() {
    var modal = document.getElementById('shipping-protection-modal');
    if (!modal) return;

    var overlay = modal.querySelector('.shp-modal__overlay');
    var closeBtn = modal.querySelector('.shp-modal__close');

    [overlay, closeBtn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('click', closeShippingProtectionModal);
    });
  }

  // Turn Upcart's description into a clickable "Learn more"
  function initShippingProtectionLearnMore(root) {
    var context = root || document;
    var descriptions = context.querySelectorAll('.upcart-addons-product-description');

    // Debug: see what we find
    console.log('[Shipping Protection] descriptions found:', descriptions.length);

    Array.prototype.forEach.call(descriptions, function (desc) {
      // prevent double init
      if (desc.dataset.shpInit === 'true') return;

      var card = desc.closest('.upcart-addons');
      if (!card) return;

      var titleEl = card.querySelector('.upcart-addons-title');
      if (!titleEl) return;

      var titleText = (titleEl.textContent || '').trim().toLowerCase();
      if (titleText !== 'shipping protection') return; // only target this addon

      desc.dataset.shpInit = 'true';
      console.log('[Shipping Protection] initializing Learn more for', titleText);

      // Create Learn more button
      var learnMore = document.createElement('button');
      learnMore.type = 'button';
      learnMore.className = 'upcart-addons-learn-more';
      learnMore.textContent = 'Learn more';

      // Replace original text
      desc.innerHTML = '';
      desc.appendChild(learnMore);

      learnMore.addEventListener('click', function () {
        openShippingProtectionModal();
      });
    });
  }

  function setupObserver() {
    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = false;

      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) return;

        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!(node instanceof HTMLElement)) return;

          // If the node itself is the description
          if (node.classList && node.classList.contains('upcart-addons-product-description')) {
            shouldRun = true;
          }

          // Or if it contains the description inside
          if (!shouldRun && typeof node.querySelector === 'function' &&
              node.querySelector('.upcart-addons-product-description')) {
            shouldRun = true;
          }
        });
      });

      if (shouldRun) {
        // Run on whole document (cheap enough) or we could limit to last added node
        initShippingProtectionLearnMore(document);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    console.log('[Shipping Protection] MutationObserver attached on body');
  }

  document.addEventListener('DOMContentLoaded', function () {
    wireModalClose();

    // First attempt (in case Upcart is already there)
    initShippingProtectionLearnMore(document);

    // Then observe for when Upcart injects its DOM later
    setupObserver();

    // Extra safety: small delay retries in case everything loads late
    setTimeout(function () {
      initShippingProtectionLearnMore(document);
    }, 1000);
    setTimeout(function () {
      initShippingProtectionLearnMore(document);
    }, 3000);
  });
})();

